import React from 'react'

import { PageLayoutContainer } from '../../../lib/page-layout-container'
import { isAdminDomain } from '../../../lib/currentDomain'
import { ReportsGeneratorWidget } from '../../features/reports-generator/ReportsGeneratorWidget'
import { AutomaticReportDeliveriesTable } from '../../../admin/features/automatic-report-deliveries-table/AutomaticReportDeliveriesTable'
import { EntitlementsEnum, hasAccessToEntitlement } from '../../../lib/entitlementUtils'
import { DummyAutomaticReportDeliveriesTable } from '../../../admin/components/dummy-automatic-report-deliveries-table'
import { Paywalled } from '../../components/paywall'
import { useEntitlements } from '../../hooks/useEntitlements'
import useText from '../../hooks/useText'

export const ReportsPage = () => {
    const text = useText()
    const entitlements = useEntitlements()

    return (
        <PageLayoutContainer>
            <ReportsGeneratorWidget />

            {isAdminDomain ? (
                hasAccessToEntitlement(EntitlementsEnum.AUTOMATED_REPORTS, entitlements) ? (
                    <AutomaticReportDeliveriesTable />
                ) : (
                    <Paywalled
                        bodyRowOne={text('lblReportsPaywallBodyRowOne')}
                        bodyRowTwo={text('lblReportsPaywallBodyRowTwo')}
                    >
                        <DummyAutomaticReportDeliveriesTable />
                    </Paywalled>
                )
            ) : null}
        </PageLayoutContainer>
    )
}
